<button
  [id]="id"
  [type]="btnType"
  [disabled]="disabled"
  class="btn"
  [ngClass]="{
    'btn_primary': type === 'primary',
    'btn_secondary h-[46px]': type === 'secondary',
    'btn_alternative': type === 'alternative',
    'bg-mg-primary-50': type === 'disabled',
    'bg-mg-error-35': type === 'disabled-alternative',
    'justify-center': isCentered,
    'justify-between': !isCentered,
    'flex-row-reverse': isReversed,
    'h-auto': isCategory,
    'max-h-[48px] h-[48px]': !isCategory,
    'flex-col gap-1 w-fit text-xs': isCategory || isIconBtn,
    'flex-row gap-2 w-full text-lg': !isCategory && !isIconBtn,
    '!text-xs !font-bold !leading-[14.4px] !text-white !h-[22px]': isPlanBtn,
  }"
>
  <mg-icons
    class="btn__icon"
    *ngIf="iconName && !loading"
    [name]="iconName"
  ></mg-icons>

  <ng-content *ngIf="!loading && !isIconBtn; else loadingTemplate">
  </ng-content>

  <ng-template #loadingTemplate>
    <mg-spinner
      [ngClass]="{
      'text-mg-primary': type === 'secondary',
      'text-mg-white': type !== 'secondary',
    }"
      [size]="'24px'"
    ></mg-spinner>
  </ng-template>
</button>
